import {
    NestedField,
} from 'app/types/form.types'
import {
    LocationFormFields,
} from '../LocationForm.types'

export const getShippingFieldDetails = (): NestedField<LocationFormFields>[] => {
    return [
        {
            name: 'latitude',
            required: true,
            componentName: 'InputSingleline',
            labelKey: 'LATITUDE',
        },
        {
            name: 'longitude',
            required: true,
            componentName: 'InputSingleline',
            labelKey: 'LONGITUDE',
        },
        {
            name: 'requiresTruckDetails',
            componentName: 'Switch',
            labelKey: 'REQUIRES_TRUCK_DETAILS',
        },
    ]
}

export default getShippingFieldDetails
